const QuantityFormatter = (quantity) => {
	if(quantity === 'repetitions') return 'reps';
	if(quantity	=== 'distance_m') return 'meters';
	return quantity;
};

export default QuantityFormatter;